import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { toast, Toaster } from "sonner";
import { IMAGES } from "../../data/content";
import { crmLogin, formatApiError } from "../../lib/crm";

export default function CrmLogin() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await crmLogin(email, password);
      navigate("/crm");
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail, "Não foi possível entrar."));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="grain-overlay flex min-h-screen items-center justify-center bg-[#141210] px-5">
      <Toaster position="top-center" richColors />
      <div className="relative z-10 w-full max-w-sm">
        <div className="rounded-3xl border border-gold/20 bg-white/5 p-8 backdrop-blur-sm sm:p-10">
          <img
            src={IMAGES.logo}
            alt="Logo Ministério AURA"
            className="mx-auto h-16 w-16 rounded-full object-cover drop-shadow-[0_4px_24px_rgba(197,160,89,0.5)]"
          />
          <p className="mt-6 text-center text-[10px] font-semibold uppercase tracking-[0.3em] text-gold">
            Área Administrativa
          </p>
          <h1 className="mt-2 text-center font-serif text-3xl text-white">
            CRM <em className="italic text-champagne">AURA</em>
          </h1>
          <form onSubmit={handleSubmit} className="mt-8 space-y-4" data-testid="crm-login-form">
            <div>
              <label htmlFor="crm-email" className="text-[10px] font-semibold uppercase tracking-[0.2em] text-white/50">
                E-mail
              </label>
              <input
                id="crm-email"
                data-testid="crm-login-email"
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="mt-2 w-full rounded-xl border border-white/10 bg-white/5 px-4 py-3 text-sm text-white outline-none transition-colors focus:border-gold/60"
                placeholder="voce@email.com"
              />
            </div>
            <div>
              <label htmlFor="crm-password" className="text-[10px] font-semibold uppercase tracking-[0.2em] text-white/50">
                Senha
              </label>
              <input
                id="crm-password"
                data-testid="crm-login-password"
                type="password"
                required
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="mt-2 w-full rounded-xl border border-white/10 bg-white/5 px-4 py-3 text-sm text-white outline-none transition-colors focus:border-gold/60"
                placeholder="••••••••"
              />
            </div>
            <button
              data-testid="crm-login-submit"
              type="submit"
              disabled={loading}
              className="w-full rounded-full bg-gold py-3.5 text-xs font-semibold uppercase tracking-[0.2em] text-ink transition-colors duration-300 hover:bg-champagne disabled:opacity-60"
            >
              {loading ? <Loader2 className="mx-auto h-4 w-4 animate-spin" /> : "Entrar"}
            </button>
          </form>
          <Link
            to="/crm/recuperar"
            data-testid="crm-forgot-link"
            className="mt-6 block text-center text-[10px] uppercase tracking-[0.2em] text-white/40 transition-colors hover:text-champagne"
          >
            Esqueci minha senha
          </Link>
        </div>
        <p className="mt-6 text-center text-[10px] uppercase tracking-[0.2em] text-white/30">
          Ministério AURA · Acesso restrito
        </p>
      </div>
    </div>
  );
}
